import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { VehicleFormComponent } from './vehicle-form/vehicle-form.component';
import { ContractFormComponent } from './contract-form/contract-form.component';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { GeneralFormComponent } from './general-form/general-form.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';
import { TimelineComponent } from '../timeline/timeline.component';
import { BrokerFormComponent } from './broker-form/broker-form.component';
import { FormAddDocumentComponent } from '../../shared/form-add-document/form-add-document.component';
import { TripleMatrixComponent } from './contract-form/triple-matrix/triple-matrix.component';
import e from 'express';

interface MatrixData {
  [months: string]: {
    [kms: string]: number;
  };
}

interface Model {
  reference: string;
  name: string;
}
interface VehicleData {
  reference: string;
  model: Model[];
  engine: string;
}
@Component({
  selector: 'app-form-add-campaign',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule,
    GeneralFormComponent,
    VehicleFormComponent,
    ContractFormComponent,
    BrokerFormComponent,
    TabsFormComponent,
    TimelineComponent,
    FormAddDocumentComponent,
    TripleMatrixComponent,
  ],

  templateUrl: './form-add-campaign.component.html',
  styleUrl: './form-add-campaign.component.css'
})
export class FormAddCampaignComponent {
  @ViewChild(FormAddDocumentComponent)
  addDocumentComponent?: FormAddDocumentComponent;
  @ViewChild(GeneralFormComponent) generalFormComponent?: GeneralFormComponent;
  @ViewChild(VehicleFormComponent) vehicleFormComponent?: VehicleFormComponent;
  @ViewChild(ContractFormComponent) contractFormComponent?: ContractFormComponent;
  @ViewChild(TripleMatrixComponent) tripleMatrixComponent?: TripleMatrixComponent;
  @ViewChild(BrokerFormComponent) brokerFormComponent?: BrokerFormComponent;

  @Output() backButtonClick = new EventEmitter<boolean>();

  @Output() addOrder = new EventEmitter<boolean>();
  @Output() formSubmit = new EventEmitter<any>();

  @Input() campaignData?: any; // Objeto opcional
    @Input() campaignPreData?: any; // Objeto opcional
  @Input() dataContainer?: any;
  @Input() document_buttons_chico = false;
  @Input() ladata: any = [];
  @Input() tab?: any;

  @Input() clientReference!: string;

  showImportantDates = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  campaign_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  @Input() isEditMode: boolean = false;
  showBrokerExcludeTab: boolean = false;
  //viene de la data
  selectTypes: any[] = [];
  newStage: string = '';
  title = '';
  activeForm = 'general';
  posiblesTabs: any[] = [
    'general',
    'notes',
    'doc-order',
    'client',
    'guarantee',
    'risk',
    'timeline',
    'contract',
    'vehicle',
    'delivery',
    'commission',
    'matrix_by_type',
  ];
  clocks: any[] = [];
  docFiles: any[] = [];
  duplicateBrokerContract: any[] = [];
  stage?: any;
  rules: any = {};
  role: any;
  helper = false;
  documentForms: string[] = ['doc-order', 'client', 'guarantee','doc-campaign'];

  updatesTabs: any[] = [];
  excludedBrokers: string[] = [];
  helperStep = 1;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private location: Location,
    private campaignsService: CampaignsService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authStateService: AuthStateService,
  ) { }

  setVariables() {
    this.clocks = this.getClocks(this.campaignData?.dates);
    this.duplicateBrokerContract =
      this.campaignData?.duplicateBrokerContract || [];
    this.back = this.campaignData?.back || '';
    this.stage = this.campaignData?.stage;
    this.rules = this.campaignData?.rules;
    this.draft = this.campaignData ? true : false;
    this.campaign_reference = this.campaignData?.reference;

    this.client_reference = this.campaignData?.client?.reference;
    this.client = this.campaignData?.client;
    this.guarantee = this.campaignData?.guarantee;
    this.guarantee_reference = this.campaignData?.guarantee?.reference;
  }

  getClocks(dates: any): any[] {
    if (dates) {
      this.clocks = Object.entries(this.campaignData.dates)
        .filter(([_, value]) => value) // solo fechas no nulas
        .map(([key, value]) => ({
          key,
          value,
        }));
    }
    return this.clocks;
  }
  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();

  }
  time = 120000;

  ngOnInit(): void {
    this.updateBrokerExcludeTabVisibility();
  }

  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft', Validators.required],
    });
    this.refrescarFormulario();
  }

  onSubmit() {
      if (this.docFiles.length > 0 && this.isDocumentForm()) {
      this.addDocumentComponent?.onSubmit();
    } else {
      this.onSubmitCampaign();
    }
  }
  onSubmitCampaign() {
    const formValues = this.getFormsValues();
    formValues.stage = 'draft';

    this.alertService.loading('swal_messages.please_wait_add_campaign');
    this.campaignsService.addData(formValues).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_campaign', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.campaignData = data.data;
            this.campaign_reference = data.data.reference;

            this.isEditMode = true;
            this.excludedBrokers = [];
            this.updateBrokerExcludeTabVisibility();

            this.refrescarFormulario();
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });
  }
  onSubmitDraft() {
    if (this.docFiles.length > 0 && this.isDocumentForm()) {
      this.addDocumentComponent?.onSubmit();
    } else {
      this.onSubmitDraftCampaign();
    }
  }
  
  onSubmitDraftCampaign(): void {
    const formValues = this.getFormsValues();

    this.alertService.loading('swal_messages.please_wait_add_order');
    this.campaignsService.updateCampaignData(this.campaign_reference, formValues).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_campaign', 'swal_messages.awesome')
          .then((result) => {
            this.campaignData = data.data;
            this.isEditMode = true;

            this.refrescarFormulario();
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });

    this.refrescarFormulario();
  }

  onSubmitOrderFast(stage: string): void {
    const originalOrder = this.campaignData;
    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    formValues['stage'] = stage;
    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        formValues[key] !== originalOrder[key] &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])

      ) {
        modifiedFields[key] = formValues[key];
      }
    }

    if (Object.keys(modifiedFields).length === 0) {
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }


    this.alertService.loading('swal_messages.updating_campaign');
    this.orderService
      .updateData(this.campaignData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          this.alertService
            .successOk('swal_messages.campaign_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.campaignData = data.data;
                this.generalFormComponent?.generalForm.patchValue({
                  notes: '',
                });
                this.updatesTabs = [];
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });

        },
      });

    this.refrescarFormulario();
  }

  onSubmitOrder(): void {
    let originalOrder = { ...this.campaignData, ...this.campaignData.pff };

    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        formValues[key] !== originalOrder[key] &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])
      ) {
        modifiedFields[key] = formValues[key];
      }
    }

    if (Object.keys(modifiedFields).length === 0) {
      // Si no hay campos modificados, no hay nada que enviar
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }
    this.alertService.loading('swal_messages.updating_order');
    this.orderService
      .updateData(this.campaignData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          // Mostrar un mensaje de éxito cuando se actualice correctamente el pedido
          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.campaignData = data.data;
                this.updatesTabs = [];
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {

          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });
        },
      });
  }
  stringToArray(original: string): string[] {
    return original
      .split(',')
      .map(item => item.trim());
  }

  getFormsValues(): any {
    const generalFormValues = this.generalFormComponent?.generalForm.getRawValue();
    const vehicleFormValues = this.vehicleFormComponent?.vehicleForm.getRawValue();
    const contractFormValues = this.contractFormComponent?.getValues();
    const tripleMatrixValues = this.tripleMatrixComponent?.getValues(
      this.contractFormComponent?.ivaEnabled ?? true
    ) || {};
    const excludedBrokersFromComponent =
      this.brokerFormComponent?.selectedItems || [];

    this.generalFormComponent?.generalForm.get('notes')?.setValue('');
    const formValues = {
      ...this.form.value,
      ...generalFormValues,
      ...vehicleFormValues,
      ...contractFormValues,
      ...tripleMatrixValues,
    };
    // Remove null/undefined to avoid sending empty disabled fields that trigger backend validation
    // Preserve broker_id as null so the backend can clear the broker association
    const preserveNullKeys = ['broker_id'];
    for (const key of Object.keys(formValues)) {
      if ((formValues[key] === null || formValues[key] === undefined) && !preserveNullKeys.includes(key)) {
        delete formValues[key];
      }
    }

    if (excludedBrokersFromComponent.length > 0) {
      formValues.excluded_brokers = excludedBrokersFromComponent;
    } else if (this.excludedBrokers && this.excludedBrokers.length > 0) {
      formValues.excluded_brokers = this.excludedBrokers;
    }
    return formValues;
  }
  pristineForms(): any {
    this.generalFormComponent?.generalForm.markAsPristine();
    this.vehicleFormComponent?.vehicleForm.markAsPristine();
    this.contractFormComponent?.contractForm.markAsPristine();
    this.brokerFormComponent?.brokerForm.markAsPristine();
  }

  setTitle() {
    this.title = this.campaignData?.name
      ? this.campaignData?.name +
      ' ' +
      (this.campaignData?.lastname
        ? this.campaignData?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.campaignData?.broker_reference
        : this.account_type === 'supplier'
          ? this.campaignData?.supplier_reference
            ? this.campaignData?.supplier_reference
            : this.campaignData?.reference
          : this.campaignData?.reference;
  }

  refrescarFormulario() {
    this.setVariables();
    this.setTitle();
    if (this.posiblesTabs.includes(this.tab)) {
      if (this.activeForm != this.tab) {
        this.activeForm = this.tab;
      }
    }
    this.pristineForms();
    // Sync triple matrix dimensions and load data
    setTimeout(() => {
      this.syncTripleMatrix();
      if (this.tripleMatrixComponent && this.campaignData) {
        this.tripleMatrixComponent.campaignData = this.campaignData;
        this.tripleMatrixComponent.loadFromCampaignData();
      }
      this.onMatrixValuesChanged();
    });
    this.alertService.close();
  }

  checkUpdateForm(form: string) {
    var result: any = false;
    switch (form) {
      case 'general':
        result = this.generalFormComponent?.checkUpdateForm();
        break;
      case 'vehicle':
        result = this.vehicleFormComponent?.checkUpdateForm();
        break;
      case 'currency':
        result = this.contractFormComponent?.checkUpdateForm();
        break;
      case 'broker_exclude':
        result = this.brokerFormComponent?.checkUpdateForm();
        break;

    }
    if (result) {
      if (!this.updatesTabs.includes(form)) {
        this.updatesTabs.push(form);
      }
    }
  }

  goDocs() {
    this.activeForm = 'doc-campaign';
  }

  changeForm(form: string) {
    this.activeForm = form;
    this.checkUpdateForm(this.activeForm);
    this.tab = this.activeForm;
  }

  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    //funcion de borrar vista
    this.closeView();

    /* const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index)); */
    this.resetFieldDisabled();
    this.draft = false;
    this.campaignData = null;
    this.campaign_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
    this.backButtonClick.emit(true);
  }

  emitAddOrder() {
    this.addOrder.emit(true);
  }

  resetFieldDisabled() {
    for (const field in this.form.controls) {
      if (this.form.controls.hasOwnProperty(field)) {
        this.form.get(field)?.enable();
      }
    }
  }

  actualizarEstadoArchivos(nuevoArrayArchivos: any[]) {
    this.docFiles = nuevoArrayArchivos;
  }

  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.campaignData.reference).subscribe({
      next: (data) => {
        this.campaignData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  isDocumentForm(): boolean {
    return this.documentForms.includes(this.activeForm);
  }

  refrescarOrder(campaignData: any) {
    this.campaignData = campaignData;
    this.setVariables();
  }

  //DUPLICATE ORDER
  duplicateOrder() {
    this.alertService
      .confirmation(
        'swal_messages.duplicate_order_title',
        'swal_messages.duplicate_order_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');
          this.orderService.duplicateOrder(this.campaign_reference).subscribe({
            next: (data) => {
              this.alertService
                .successOk('swal_messages.duplicate_order_success')
                .then((result) => {
                  if (result.isConfirmed) {
                    this.campaignData = data.data;
                    this.updatesTabs = [];
                    this.refrescarFormulario();
                    this.emitAddOrder();
                  }
                });
            },
            error: (error) => {
              this.alertService.error('swal_messages.order_not_found');
            },
          });
        } else {
        }
      });
  }


  //PASA MANOS DE EVENTOS//
  @Output() emitOpenAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenAssigneeCreateForm = new EventEmitter<boolean>();
  @Output() emitCloseClientForm = new EventEmitter<boolean>();
  @Output() emitCloseAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenClientForm = new EventEmitter<string>();
  @Output() emitOpenAddressesForm = new EventEmitter<boolean>();
  @Output() emitCloseAddressesForm = new EventEmitter<boolean>();

  openAssigneeForm(assignee: any) {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(assignee);
  }

  openClientForm(optAdd: string) {
    this.document_buttons_chico = true;
    this.emitOpenClientForm.emit(optAdd);
  }

  openAssigneeCreateForm() {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(true);
  }

  openAddressesForm() {
    this.document_buttons_chico = true;
    this.emitOpenAddressesForm.emit(true);
  }

  //NOTAS
  activeNotesTab: string = 'public';

  onTabChanged(tab: string) {
    this.activeNotesTab = tab;
  }

  closeView() {
    this.orderService.closeView(this.campaign_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  closeViewOverlay() {
    this.orderService.closeView(this.campaign_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });

    this.draft = false;
    this.campaignData = null;
    this.campaign_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
  }

  goContract(url: string) {
    const nuevaURL = url;
    this.router.navigate([url]);
  }

  updateView() {
    this.orderService.updateView(this.campaign_reference).subscribe({
      next: (data) => {

        this.duplicateBrokerContract = data.data.duplicateBrokerContract;
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  private updateBrokerExcludeTabVisibility(): void {
    if (this.isEditMode) {
      this.showBrokerExcludeTab = !this.campaignData?.broker_id;
    } else {
      this.showBrokerExcludeTab = true;
    }
  }

  hasExcludedBrokers: boolean = false;

  onExcludedBrokersChanged(brokers: string[]): void {
    this.excludedBrokers = brokers;
    this.hasExcludedBrokers = brokers.length > 0;
  }

  onMatrixDimensionsChanged(dims: { headers: string[], rowLabels: string[] }): void {
    this.tripleMatrixComponent?.syncDimensions(dims.headers, dims.rowLabels);
  }

  onMatrixValuesChanged(): void {
    if (!this.tripleMatrixComponent || !this.contractFormComponent) return;
    this.tripleMatrixComponent.syncPriceMatrix(
      this.contractFormComponent.rows,
      this.contractFormComponent.headers
    );
  }

  onIvaToggled(ivaEnabled: boolean): void {
    if (ivaEnabled) {
      this.tripleMatrixComponent?.applyIva();
    } else {
      this.tripleMatrixComponent?.removeIva();
    }
  }

  syncTripleMatrix(): void {
    if (!this.tripleMatrixComponent || !this.contractFormComponent) return;
    const dims = this.contractFormComponent.getMatrixDimensions();
    this.tripleMatrixComponent.syncDimensions(dims.headers, dims.rowLabels);
  }

  onBrokerSelected(brokerId: string): void {
    const hadBrokerExcluded = this.excludedBrokers.length > 0;

    if (brokerId && brokerId !== '') {
      this.showBrokerExcludeTab = false;

      if (hadBrokerExcluded) {
        this.excludedBrokers = [];
        this.hasExcludedBrokers = false;

        if (this.brokerFormComponent) {
          this.brokerFormComponent.clearSelectionExternally();
        }
      }

      if (this.activeForm === 'broker_exclude') {
        this.activeForm = 'general';
      }
    } else {
      this.showBrokerExcludeTab = true;
    }
  }

}
